import { ApiService } from "./ApiService"

export class WaDeviceService {

    static uri = '/wa/device';

    static get() {
        return ApiService.get(`${this.uri}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'aplication/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static update({ id, data }) {
        return ApiService.put(`${this.uri}/update/${id}`, data, {
            headers: {
                'Content-Type': 'aplication/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static logout({ data }) {
        return ApiService.post(`${this.uri}/logout/`, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    // WaDeviceService.js
    static generateQR({ params }) {
        return ApiService.get(`${this.uri}/generate-qr`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
    static delete({ id }) {
        return ApiService.delete(`${this.uri}/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token-radiustrend")}`,
            },
        });
    }
}